/* Theme-owned navigation; article HTML and existing anchors remain the source. */
(() => {
  function initialize(root) {
    if (root.dataset.articleTocReady) return;
    root.dataset.articleTocReady = 'true';
    const content = root.querySelector('.article-template__content');
    const containers = [...root.querySelectorAll('[data-article-toc]')];
    const headings = [...(content?.querySelectorAll('h2') || [])].filter(
      heading => heading.textContent.trim() && !heading.closest('.ecom-contents')
    );
    containers.forEach(container => {
      const host = container.closest('.sidebar-section, .article-template__mobile-toc');
      if (host) host.hidden = !headings.length;
    });
    if (!headings.length || !containers.length) return;

    headings.forEach((heading, index) => {
      if (heading.id) return;
      const base = heading.textContent.trim().toLowerCase()
        .replace(/[^\p{L}\p{N}]+/gu, '-').replace(/^-|-$/g, '') || `section-${index + 1}`;
      let id = base;
      let suffix = 2;
      while (document.getElementById(id)) id = `${base}-${suffix++}`;
      heading.id = id;
    });

    const links = containers.map(container => {
      const list = document.createElement('ul');
      const items = headings.map(heading => {
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${encodeURIComponent(heading.id)}`;
        link.textContent = heading.textContent.trim();
        item.append(link);
        list.append(item);
        return link;
      });
      container.replaceChildren(list);
      return items;
    });

    let active = -1;
    let queued = false;
    const update = () => {
      queued = false;
      const offset = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 72;
      const sidebar = root.querySelector('.article-sidebar-left');
      if (sidebar) sidebar.classList.toggle('article-sidebar-left--static', sidebar.offsetHeight > innerHeight - offset - 40);
      let next = 0;
      headings.forEach((heading, index) => {
        if (heading.getBoundingClientRect().top <= offset + 32) next = index;
      });
      if (next === active) return;
      active = next;
      links.forEach((items, containerIndex) => {
        items.forEach((link, index) => {
          link.classList.toggle('active', index === active);
          if (index === active) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        });
        const container = containers[containerIndex];
        const link = items[active];
        if (!container.getClientRects().length || container.matches(':hover, :focus-within')) return;
        const bounds = container.getBoundingClientRect();
        const rect = link.getBoundingClientRect();
        if (rect.top < bounds.top || rect.bottom > bounds.bottom) {
          container.scrollTop += rect.top - bounds.top - container.clientHeight / 2 + rect.height / 2;
        }
      });
    };
    const schedule = () => {
      if (!queued) { queued = true; requestAnimationFrame(update); }
    };
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    root.addEventListener('load', schedule, true);
    update();
    const teardown = event => {
      if (!event.target.contains(root)) return;
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      root.removeEventListener('load', schedule, true);
      document.removeEventListener('shopify:section:unload', teardown);
    };
    document.addEventListener('shopify:section:unload', teardown);
  }
  const setup = () => document.querySelectorAll('.article-template--editorial').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
  document.addEventListener('shopify:section:load', setup);
})();
